// extracted by mini-css-extract-plugin
module.exports = {"modalHeading":"styles_modalHeading__Ck4jz","modalDescription":"styles_modalDescription__8NocF","holidaysDialog":"styles_holidaysDialog__zU3s_"};